// Copyright (c) Cosmo Tech.
// Licensed under the MIT license.
import React from 'react';
import { useTranslation } from 'react-i18next';
import DownloadIcon from '@mui/icons-material/Download';
import { Button, Grid } from '@mui/material';
import { FadingTooltip } from '../../../../../../ui';
import { useScenarioExportButton } from './ScenarioExportButtonHook';

export const ScenarioExportButton = () => {
  const { t } = useTranslation();
  const { showButton, downloadScenarioData } = useScenarioExportButton();

  if (!showButton) return null;
  return (
    <Grid item>
      <FadingTooltip
        title={t('commoncomponents.button.scenario.parameters.scenarioExport.tooltip', 'Download scenario data')}
      >
        <Button
          data-cy="export-scenario-button"
          variant="contained"
          startIcon={<DownloadIcon />}
          onClick={downloadScenarioData}
        >
          {t('commoncomponents.button.scenario.parameters.scenarioExport.label', 'Export')}
        </Button>
      </FadingTooltip>
    </Grid>
  );
};
